// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEpmMasterFunctionalityMutationVariables = Types.Exact<{
  deleteEpmMasterFunctionalityId: Types.Scalars['ID']['input'];
}>;

export type DeleteEpmMasterFunctionalityMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEpmMasterFunctionality'
>;

export const DeleteEpmMasterFunctionalityDocument = /*#__PURE__*/ gql`
    mutation DeleteEpmMasterFunctionality($deleteEpmMasterFunctionalityId: ID!) {
  deleteEpmMasterFunctionality(id: $deleteEpmMasterFunctionalityId)
}
    `;
export type DeleteEpmMasterFunctionalityMutationFn = Apollo.MutationFunction<
  DeleteEpmMasterFunctionalityMutation,
  DeleteEpmMasterFunctionalityMutationVariables
>;

/**
 * __useDeleteEpmMasterFunctionalityMutation__
 *
 * To run a mutation, you first call `useDeleteEpmMasterFunctionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpmMasterFunctionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpmMasterFunctionalityMutation, { data, loading, error }] = useDeleteEpmMasterFunctionalityMutation({
 *   variables: {
 *      deleteEpmMasterFunctionalityId: // value for 'deleteEpmMasterFunctionalityId'
 *   },
 * });
 */
export function useDeleteEpmMasterFunctionalityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEpmMasterFunctionalityMutation,
    DeleteEpmMasterFunctionalityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEpmMasterFunctionalityMutation, DeleteEpmMasterFunctionalityMutationVariables>(
    DeleteEpmMasterFunctionalityDocument,
    options,
  );
}
export type DeleteEpmMasterFunctionalityMutationHookResult = ReturnType<typeof useDeleteEpmMasterFunctionalityMutation>;
export type DeleteEpmMasterFunctionalityMutationOptions = Apollo.BaseMutationOptions<
  DeleteEpmMasterFunctionalityMutation,
  DeleteEpmMasterFunctionalityMutationVariables
>;
